import styled from 'styled-components';
import {Link} from 'react-router-dom';

export const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  li {
    margin: 5px 2px;
  }
  img {
    display: block;
    width: 46px;
    min-width: 46px;
    min-height: 46px;
    height: 46px;
  }
`;
export const AchievesLink = styled(Link)`
  color: white;
  border-bottom: 2px solid white;
  transition: opacity .3s ease;
  &:hover, &:focus {
    border-bottom-color: transparent;
    opacity: .7;
  }
`;
